import { futureValueStepUpSIP } from "../../engine/calculations";
import { currencyAxis, yearsAxis } from "./reckonerAxes";

const config = {
  key: "rr-sip-stepup",
  title: "SIP + Step-Up SIP Ready Reckoner",
  category: "Ready Reckoners",
  description: "See the future value of a SIP that rises every year, across a range of amounts and durations.",
  reckoner: true,
  rowAxis: currencyAxis("Starting Monthly SIP", [5_000, 10_000, 15_000, 20_000, 25_000]),
  colAxis: yearsAxis("Years", [5, 10, 15, 20, 25, 30]),
  extraFields: [
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
    { key: "stepUpPct", label: "Annual step-up", type: "percent", default: 10, min: 0, max: 50 },
  ],
  computeCell(monthly, years, extra) {
    const annualRate = (Number(extra.returnRate) || 0) / 100;
    const stepUpPct = (Number(extra.stepUpPct) || 0) / 100;
    return futureValueStepUpSIP(monthly, annualRate, years, stepUpPct);
  },
};

export default config;
